/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <nav>
        <div className="menu-icon" onClick={toggleMenu}>
          <div className={`bar ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`bar ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`bar ${isMenuOpen ? 'open' : ''}`}></div>
        </div>
        <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <li><a href="#home">// Home</a></li>
          <li><a href="#expertise">// Expertise</a></li>
          <li><a href="#projects">// Projects</a></li>
          <li><a href="#professional-experience">// Professional Experience</a></li>
          <li><a href="#contact">// Contact</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
